import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "@mui/material/AppBar";
import { Toolbar } from "@mui/material";

const useStyles = makeStyles(theme => ({
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: 1,
    paddingLeft: theme.sizes.sideNavBarWidthCondensed,
    boxShadow: "none",
    borderTop: `solid 1px ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(0)
    }
  },
  toolbar: {
    padding: theme.spacing(0, 3),
    margin: theme.spacing(1, 0)
  }
}));

const BottomNavbar = ({ children }) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" color="default" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>{children}</Toolbar>
    </AppBar>
  );
};

export default BottomNavbar;
